import gql from 'graphql-tag';
import { entityFragment, themeFragment } from '@signing-page/api/entity/graphql/entity.fragment';

export const entityQuery = gql`
  query Entity {
    entity {
      ...entityFragment
      isDisableComment
    }
  }
  ${entityFragment}
`;

export const themeQuery = gql`
  query theme($documentId: String!) {
    theme(documentId: $documentId) {
      ...themeFragment
    }
  }
  ${themeFragment}
`;
